export default __webpack_public_path__ + "static/media/013-fuel.5bc17e61.svg";